$(document).ready(function() {

  // Drill Nav Menu
  var item = $('.drill-nav__item');
  // check if it has child menu and add class if so
  item.each(function(){
    if (this.children.length > 1) {
      $(this).addClass('has-child-menu');
    }
  });

  $(".drill-nav__item:not(.is-active)").on("mouseover", function() {
    $(".drill-nav__item.is-active").removeClass("is-active").addClass("is-inactive");
  });

  $(".drill-nav__item:not(.is-inactive)").on("mouseout", function() {
    $(".drill-nav__item.is-inactive").removeClass("is-inactive").addClass("is-active");
  });
});
